import { useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import { ChartPrintContext } from './context'
import { GET_CHART_IMAGE } from './query'
import type { ChartConfig } from './types'

export function ChartPrintProvider({ children }) {
  const { createToast } = useToast()
  const [getChartImage] = useLazyQuery(GET_CHART_IMAGE)
  const t = useTranslate()

  const [chartsConfig, setChartsConfig] = useState<ChartConfig[]>([])
  const [isPrinting, setIsPrinting] = useState(false)

  async function getPrint(chartTitle: string, dataUniverse?: string) {
    if (isPrinting) {
      return
    }

    setIsPrinting(true)

    const formattedOptions = chartsConfig.map(item => {
      const chart = {
        ...item.options,
        colors: item.colors,
        series: item.series,
      }
      return chart
    })

    const stringified = JSON.stringify(formattedOptions)
    const colors = JSON.stringify(chartsConfig[0]?.colors)

    const variables = {
      categories: JSON.stringify(chartsConfig[0].categories),
      charts: stringified,
      colors,
      dataUniverse,
      title: chartTitle,
      footer: chartsConfig[0]?.footer,
    }

    createToast({
      content: t(TOLGEE_GLOBALS.startDownload),
    })
    getChartImage({
      variables: {
        input: variables,
      },
    })
      .then(({ data }) => {
        const base64Img = data?.getChartImage
        if (!base64Img) {
          createToast({
            content: t(TOLGEE_GLOBALS.somethingWentWrong),
          })
          return
        }
        const a = document.createElement('a') //Create <a>
        a.href = base64Img //Image Base64 Goes here
        a.download = `${chartTitle}.png` //File name Here
        a.click() //Downloaded file
        return base64Img
      })
      .then(data => {
        if (data) {
          createToast({
            content: t(TOLGEE_GLOBALS.downloadSuccess),
          })
        }
      })
      .catch(err => {
        console.error('Error @GET_CHART_IMAGE >>>>>', err)
        createToast({
          content: 'Something went wrong',
        })
      })
      .finally(() => {
        setIsPrinting(false)
      })

    const { PRINT_ELEMENT } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(PRINT_ELEMENT, {
      printedElement: chartTitle,
      printSource: 'Print button',
    })
  }

  const contextValue = {
    setChartsConfig,
    getPrint,
    isPrinting,
  }

  return <ChartPrintContext.Provider value={contextValue}>{children}</ChartPrintContext.Provider>
}
